// assets/linked-swatches.js (ensure this script is loaded with defer)

class LinkedSwatches {
  constructor() {
    this.button = document.getElementById('ShowMoreSwatches');
    this.list = document.getElementById('SwatchList');
    
    // Exit if the elements don't exist
    if (!this.button || !this.list) {
      return;
    }

    this.showText = this.button.querySelector('.show-text');
    this.hideText = this.button.querySelector('.hide-text');

    this.button.addEventListener('click', this.toggleSwatches.bind(this));
  }

  toggleSwatches() {
    const isExpanded = this.list.classList.toggle('is-open');

    // Toggle ARIA and button text for Accessibility
    this.button.setAttribute('aria-expanded', isExpanded);
    this.showText.classList.toggle('hidden', isExpanded);
    this.hideText.classList.toggle('hidden', !isExpanded);
  }
}

// Initialise the functionality once the DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
  new LinkedSwatches();
});